import { logger } from '@zep/core-logger';
import { useOpenWindow } from '@/hooks';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';
import { cn } from '@/utils/tailwind.util';
import { PublicQuizTooltip } from './PublicQuizTooltip';
interface AuthorTagChipProps {
  authorName: string;
  isOfficial?: boolean;
  authorHashId: string;
}

/** 작성자 프로필 열기. 칩과 원작자 드롭다운(`OriginalAuthor`)이 같은 이동·트래킹·가드를 쓴다. */
export const useOpenAuthorProfile = () => {
  const openWindow = useOpenWindow();
  const isInExternalPlatform = useIsInExternalPlatform();
  return {
    /** 외부 교육 플랫폼(LTI·Classroom) 안에서는 프로필로 나가지 않는다 */
    canOpen: !isInExternalPlatform,
    open: (authorHashId: string) => {
      if (isInExternalPlatform) return;
      logger.track('click_user_profile');
      openWindow(`/profile/${authorHashId}`);
    }
  };
};
export const AuthorTagChip = ({
  authorName,
  isOfficial,
  authorHashId
}: AuthorTagChipProps) => {
  const {
    canOpen,
    open
  } = useOpenAuthorProfile();
  const handleClick = (e: React.MouseEvent) => {
    if (!canOpen) return;
    e.preventDefault();
    e.stopPropagation();
    open(authorHashId);
  };
  return <div className={cn('group inline-flex w-fit items-center gap-4xs rounded-xl border-[1px] border-alternative px-xs py-3xs', canOpen && 'cursor-pointer')} onClick={handleClick} data-sentry-component="AuthorTagChip" data-sentry-source-file="AuthorTagChip.tsx">
      <span className={cn('truncate text-center text-body-sm-semibold text-neutral', canOpen && 'group-hover:text-assistive')}>
        {authorName}
      </span>
      {isOfficial && canOpen && <PublicQuizTooltip triggerIconSize={'2xs'} onClick={handleClick} />}
    </div>;
};